import $ from "jquery";
import Cookies from "js-cookie";

import morningstarFunctions from "./morningstar-functions";

const {
  cssConfig,
  configuration,
  elementBindings,
  getFreshToken,
  getTokenConfig,
  getQueryParam,
  handleMorningStarError,
} = morningstarFunctions;

function init(): void {
  const $morningstarScreener = $(".js-morningstar-screener");

  if ($morningstarScreener.length === 0) {
    return;
  }

  const {
    tokenApiUrl,
    universeId,
    componentId,
    namespace,
    environment,
    enablePdf,
    reportUrl,
    investmentCompareUrl,
    xrayUrl,
    enableComparerTool,
    enableXrayTool,
  } = $morningstarScreener[0].dataset;

  function loadScreener(token) {
    const appConfig = {
      components: {
        ecScreener: {
          type: componentId,
          settings: {
            universeId,
            // Report settings
            fieldDefinitions: {
              investment: {
                fieldSettings: {
                  hyperlink: {
                    urlFields: ["secId", "currencyId"],
                    url: reportUrl + "index.aspx#?id={{0}}&idType=msid&CurrencyId={{1}}&marketCode=",
                    target: "_self",
                  },
                },
              },
            },
          },
          components: {
            actionBar: {
              type: "ecActionContainer",
              settings: {
                primaryActionsCount: {
                  defaults: 3,
                },
                showMoreActionsHeader: true,
                actions: [
                  {
                    instanceId: "actionCompare",
                  },
                  {
                    instanceId: "actionShowXray",
                  },
                  {
                    actionType: "custom",
                    instanceId: "actionScreenerPdf",
                  },
                  {
                    instanceId: "addToList",
                  },
                  {
                    instanceId: "viewList",
                  },
                ],
              },
            },
          },
        },
      },
    };
    let count = 3;
    if (!enablePdf || enablePdf.toLowerCase() === "false") {
      appConfig.components.ecScreener.components.actionBar.settings.actions.splice(2, 1);
      count = count - 1;
    }
    if (!enableXrayTool || enableXrayTool.toLowerCase() === "false") {
      appConfig.components.ecScreener.components.actionBar.settings.actions.splice(1, 1);
      count = count - 1;
    }
    if (!enableComparerTool || enableComparerTool.toLowerCase() === "false") {
      appConfig.components.ecScreener.components.actionBar.settings.actions.splice(0, 1);
      count = count - 1;
    }
    if (!universeId || universeId.length === 0) {
      delete appConfig.components.ecScreener.settings.universeId;
    }
    appConfig.components.ecScreener.components.actionBar.settings.primaryActionsCount.defaults = count;

    const settings = {
      angular: elementBindings(componentId),
      configuration: configuration(namespace, environment, appConfig),
      instrumentation: {
        providers: [
          {
            provider: "console",
            level: "fatal|error",
          },
        ],
      },
      apiTokens: getTokenConfig(token),
      css: cssConfig,
    };

    window["morningstar"].loader
      .load(settings)
      .then(function () {
        // (manifest)
        window.console.log("Component loaded successfully");
        const screenerInstance = window["morningstar"].asterix.instanceRegistry.find("ecScreener");

        // Compare tool
        const actionCompare = function () {
          // (event)
          const target = "_self";
          const selectedItems = screenerInstance.getParameter("selectedItemKeys"),
            selectedItemsViewList = screenerInstance.getParameter("selectedItemKeysViewList");
          if (
            selectedItems &&
            selectedItems.length &&
            selectedItems.length <= 3 &&
            !screenerInstance.getModelProperty("showViewList")
          ) {
            const urlParameters = {
              currencyId: screenerInstance.getParameter("currencyId"),
              languageId: screenerInstance.getParameter("languageId"),
              secIds: selectedItems.join("|"),
            };
            const href =
              investmentCompareUrl + "#?securityIds={{secIds}}&currencyId={{currencyId}}&languageId={{languageId}}";

            window.open(window["morningstar"].asterix.util.url.parameterize(href, urlParameters), target);
          } else if (
            selectedItemsViewList &&
            selectedItemsViewList.length &&
            selectedItemsViewList.length <= 3 &&
            screenerInstance.getModelProperty("showViewList")
          ) {
            const urlParameters = {
              currencyId: screenerInstance.getParameter("currencyId"),
              languageId: screenerInstance.getParameter("languageId"),
              secIds: selectedItemsViewList.join("|"),
            };
            const href =
              investmentCompareUrl + "#?securityIds={{secIds}}&currencyId={{currencyId}}&languageId={{languageId}}";
            window.open(window["morningstar"].asterix.util.url.parameterize(href, urlParameters), target);
          } else if (document.getElementById("notificationsContainer")) {
            const notificationsContainer = document.getElementById("notificationsContainer");
            (notificationsContainer as any).addNotification({
              settings: {
                type: "warning",
                dismissAction: true,
                message: "compareWarning",
              },
              labels: {
                en: {
                  compareWarning: "Please select between 1 and 3 funds to compare",
                },
              },
            });
          } else {
            window.alert("Please select between 1 and 3 funds to compare");
          }
        };
        window["morningstar"].asterix.instanceRegistry
          .find("ecScreener.actionBar.actionCompare")
          .on("click", actionCompare);
        window["morningstar"].asterix.instanceRegistry
          .find("ecScreener.viewListActionBar.viewListActionCompare")
          .on("click", actionCompare);

        // Xray tool
        const getXrayUrl = function (param) {
          let url = "";
          const selectedItems = screenerInstance.getParameter(param);
          if (selectedItems && selectedItems.length && selectedItems.length <= 5) {
            const urlParameters = {
              currencyId: screenerInstance.getParameter("currencyId"),
              languageId: screenerInstance.getParameter("languageId"),
              idList: selectedItems.join("|"),
              idType: "msid",
              benchmarkId: "EUCA000507",
            };
            url = window["morningstar"].asterix.util.url.parameterize(
              xrayUrl +
                "?languageId=" +
                getQueryParam("languageId", "en-GB") +
                "&universeId=" +
                getQueryParam("universeId", "FXALL$$ALL_4009") +
                "&msIds={{idList}}&msIdType={{idType}}&currencyId={{currencyId}}&bmarkId={{benchmarkId}}",
              urlParameters
            );
          } else {
            alert("Please select between 1 and 5 funds for XRay");
          }
          return url;
        };
        window["morningstar"].asterix.instanceRegistry
          .find("ecScreener.actionBar.actionShowXray")
          .on("click", function () {
            const url = getXrayUrl("selectedItemKeys");
            if (url) {
              window.open(url, "_self");
            }
          });
        window["morningstar"].asterix.instanceRegistry
          .find("ecScreener.viewListActionBar.viewListActionShowXray")
          .on("click", function () {
            const url = getXrayUrl("selectedItemKeysViewList");
            if (url) {
              window.open(url, "_self");
            }
          });

        // PDF tools
        const openScreenerPdf = function (param) {
          const selectedItems = screenerInstance.getParameter(param);
          if (selectedItems && selectedItems.length > 0) {
            const form = document.createElement("form");
            form.setAttribute("method", "post");
            form.setAttribute("action", "https://lt.morningstar.com/au5uc45cvn/fundquickrankpdf/default.aspx");
            form.setAttribute("target", "_blank");

            let input = document.createElement("input");
            input.type = "hidden";
            input.name = "SecIdList";
            input.value = selectedItems.join(",");
            form.appendChild(input);

            input = document.createElement("input");
            input.type = "hidden";
            input.name = "currencyId";
            input.value = screenerInstance.getParameter("currencyId");
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
          } else {
            window.alert("Please select one or more funds for output to PDF");
          }
        };
        window["morningstar"].asterix.instanceRegistry
          .find("ecScreener.actionBar.actionScreenerPdf")
          .on("click", function () {
            openScreenerPdf("selectedItemKeys");
          });
        window["morningstar"].asterix.instanceRegistry
          .find("ecScreener.viewListActionBar.viewListActionScreenerPdf")
          .on("click", function () {
            openScreenerPdf("selectedItemKeysViewList");
          });
      })
      .catch(function (error: any) {
        handleMorningStarError(error, tokenApiUrl, loadScreener);
      });
  }

  const token = Cookies.get("MSToken");
  if (token) {
    loadScreener(token);
  } else {
    getFreshToken(tokenApiUrl, loadScreener);
  }
}

export default { init };
